import { render, staticRenderFns } from "./DocumentPreviewContainer.vue?vue&type=template&id=3fdbc11d&scoped=true"
import script from "./DocumentPreviewContainer.vue?vue&type=script&lang=js"
export * from "./DocumentPreviewContainer.vue?vue&type=script&lang=js"
import style0 from "./DocumentPreviewContainer.vue?vue&type=style&index=0&id=3fdbc11d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdbc11d",
  null
  
)

export default component.exports